import React from "react"
import { connect } from "react-redux"

import { Box, Flex } from "components/common"

const InternalVideo = ({ mountedPath }) => {
  if (mountedPath && mountedPath.includes("carmilla")) {
    return (
      <Flex justifyContent="center">
        <Box
          height={{ _: "200px", tablet: "315px" }}
          width={{ _: "100%", tablet: "560px" }}
        >
          <iframe
            allowFullScreen
            frameBorder="0"
            height="100%"
            src="https://www.youtube.com/embed/xQ2Ee1dhCz4"
            width="100%"
          ></iframe>
        </Box>
      </Flex>
    )
  } else {
    return null
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    mountedPath: state.collection.mountedPath,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
}

const CarmillaVideo = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalVideo)

export default CarmillaVideo
